/**
 * PaymentMethod Repository Factory
 *
 * 환경 변수(USE_MOCK_DATA)에 따라 Mock 또는 GoogleSheets Repository를 반환합니다.
 */

import { env } from '@/core/config/env'
import { logger } from '@/core/logger'
import { MockPaymentMethodRepository } from './MockPaymentMethodRepository'
import { GoogleSheetsPaymentMethodRepository } from './GoogleSheetsPaymentMethodRepository'
import type { PaymentMethodRepository } from './PaymentMethodRepository'

/**
 * PaymentMethod Repository 인스턴스 생성
 *
 * env.USE_MOCK_DATA 값에 따라 자동으로 선택됩니다.
 *
 * @returns PaymentMethodRepository 구현체
 */
export function createPaymentMethodRepository(): PaymentMethodRepository {
  if (env.USE_MOCK_DATA) {
    logger.info('🔧 Mock PaymentMethod Repository 사용')
    return new MockPaymentMethodRepository()
  }

  logger.info('🔗 Google Sheets PaymentMethod Repository 사용')
  return new GoogleSheetsPaymentMethodRepository()
}

/**
 * 전역 PaymentMethod Repository 인스턴스
 *
 * 애플리케이션 전체에서 동일한 인스턴스를 사용합니다.
 */
export const paymentMethodRepository = createPaymentMethodRepository()

// Re-export 타입
export type { PaymentMethodRepository } from './PaymentMethodRepository'
export type { PaymentMethod } from '../types/PaymentMethod'
